import { render, staticRenderFns } from "./BrExpirySoonBar.vue?vue&type=template&id=6f61f650&"
import script from "./BrExpirySoonBar.vue?vue&type=script&lang=js&"
export * from "./BrExpirySoonBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports